var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useState } from "react";
import LocalStorageService from "./services/localStorage";
var AuthContext = createContext(undefined);
export var useAuth = function () {
    var context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuth debe ser usado dentro de un AuthProvider");
    }
    return context;
};
export var AuthProvider = function (_a) {
    var children = _a.children;
    var storageKey = "assurehub";
    var localStorageService = new LocalStorageService(storageKey);
    var _b = useState(localStorageService.isAuthenticated()
        ? "authenticated"
        : "no-authenticated"), status = _b[0], setStatus = _b[1];
    return (_jsx(AuthContext.Provider, __assign({ value: { status: status, setStatus: setStatus } }, { children: children })));
};
